import { useQuery } from '@apollo/client';
import type { ListingsApi } from '@seek/sbiz-shared-types';
import { Alert, Box, Heading, Stack, Text } from 'braid-design-system';

import { LegacyCarousel } from 'src/components/LegacyCarousel/LegacyCarousel';
import ListingCard from 'src/components/LegacyCarousel/components/ListingCard/ListingCard';
import { GetFeaturedFranchisesDocument } from 'src/generated/graphql';
import { isNonNullable } from 'src/utils';

const makeCarouselCards = (listingData: ListingsApi.FeaturedFranchise[]) => {
  const cards = listingData.map((listing, index) => (
    <span key={index} data-testid="carouselContent">
      <ListingCard htag={`featured-opportunity-item-${index}`} {...listing} />
    </span>
  ));
  return cards;
};

const FeaturedOpportunities = () => {
  const { data, loading, error } = useQuery(GetFeaturedFranchisesDocument);
  // Change the following number if looking to render more franchises
  const displayedFranchises = 3;

  const listings =
    data?.featuredFranchises
      ?.filter(isNonNullable)
      .slice(0, displayedFranchises) ?? [];
  const emptyData = Array(displayedFranchises).fill({
    title: '',
    url: '',
    imageUrl: '',
    location: '',
    investment: '',
    htag: '',
  });

  return (
    <Box background="promote" padding="medium" borderRadius="large">
      <Stack space="medium">
        <Heading level="3" component="h2">
          Featured opportunities
        </Heading>

        {error ? (
          <Alert tone="critical">
            <Text
              data={{
                testid: 'errorNotice',
              }}
            >
              Error retrieving featured opportunities
            </Text>
          </Alert>
        ) : (
          <LegacyCarousel
            items={
              loading
                ? makeCarouselCards(emptyData)
                : makeCarouselCards(listings)
            }
          />
        )}
      </Stack>
    </Box>
  );
};

export default FeaturedOpportunities;
